import { object, boolean } from 'yup';

const extendSchemaWithDefects = (base, defectsList = []) => {
  const defectFieldNames = defectsList.map(item => `defect_${item.id ?? ''}`);

  const defectFieldsSchema = defectFieldNames.reduce((acc, name) => {
    acc[name] = boolean().default(false);
    return acc;
  }, {});

  return base.concat(object().shape(defectFieldsSchema));
};

export { extendSchemaWithDefects };
